<script setup lang="ts">
import { InteractiveRating } from '~/components/ui/rating'
import type { IRatingCriteria } from '~/composables/useRating'

const props = defineProps<{
  criteria: IRatingCriteria[]
}>()

// The parent owns the values so it can reset them when the rated entity changes.
const ratings = defineModel<Record<number, number>>({ required: true })

const sortedCriteria = computed(() => {
  return [...props.criteria].sort((a, b) => {
    if (a.display_order !== undefined && b.display_order !== undefined) {
      return a.display_order - b.display_order
    }
    return a.name.localeCompare(b.name)
  })
})

const updateCriteriaRating = (criteriaId: number, rating: number) => {
  ratings.value = { ...ratings.value, [criteriaId]: rating }
}
</script>

<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <template v-for="criterion in sortedCriteria" :key="criterion.id">
      <div class="space-y-2">
        <InteractiveRating
          :model-value="ratings[criterion.id] || 0"
          size="sm"
          @update:model-value="updateCriteriaRating(criterion.id, $event)"
        />
        <h4 class="text-sm font-medium text-gray-900">
          {{ criterion.name }}
        </h4>
        <p v-if="criterion.description" class="text-xs text-gray-600">
          {{ criterion.description }}
        </p>
      </div>
    </template>
  </div>
</template>
